import {
  Box,
  Grid,
  IconButton,
  Popover,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import LogoIconWhite from 'common/shared-ui/src/icons/LogoIconWhite';

import MenuIcon from '../../../../packages/common/shared-ui/src/icons/MenuIcon';
import { useTranslation } from '../../../../packages/common/utils/getLocalString';
import { generateRedirectUrl } from '../../../../packages/common/utils/getRedirectUrl';
import { toggleDrawer } from '../../app/redux/reducers/userSlice';
import HeaderNavIcons from '../HeaderNavIcons/HeaderNavIcons';
import SearchInput from '../SearchInput/SearchInput';
import UserAvatar from '../UserAvatar/UserAvatar';

// Original class: Header
const StyledHeader = styled(Grid)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 2000,
  backgroundColor: theme.palette.text.primary,
  padding: '10px 20px',

  [theme.breakpoints.down('sm')]: {
    padding: '6px 6px 10px 6px',
    height: 80,
  },
}));
// Original class: headerContainer
const StyledHeaderContainer = styled(Grid)(({ theme }) => ({
  // maxWidth: 1280,
  padding: '0 10px 0 25px',

  marginLeft: theme.spacing(8.5),

  [theme.breakpoints.down(1330)]: {
    // maxWidth: 944,
  },

  [theme.breakpoints.down('lg')]: {
    // maxWidth: 717,
    padding: theme.spacing(0, 5),
  },

  [theme.breakpoints.down('md')]: {
    padding: 0,
  },

  [theme.breakpoints.down('sm')]: {
    //maxWidth: 320,
    marginLeft: 0,
  },
}));
// Original class: headerLogo
const StyledHeaderLogo = styled(Link)(({ theme }) => ({
  display: 'flex',
  width: theme.spacing(22),
  height: theme.spacing(10),
}));
// Original class: avatarBlock
const StyledAvatarBlock = styled(Box)(theme => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
}));
// Original class: userSettingsLink
const StyledUserSettingsLink = styled(Popover)(({ theme }) => ({
  '&.MuiPopover-root': {
    zIndex: 2000,
  },

  '& .MuiPopover-paper': {
    padding: theme.spacing(3, 4),
    backgroundColor: 'white',
    borderRadius: theme.spacing(4),
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(-5),
  },
}));
// Original class: logoutButton
const StyledLogoutButton = styled(Link)(theme => ({
  cursor: 'pointer',
  color: '#7174AC',
  display: 'block',
}));
const Header = () => {
  const getLocalString = useTranslation();
  const userLastName = useSelector(state => state.user.info.lastName);
  const userFirstName = useSelector(state => state.user.info.firstName);
  const userFullNameArray = useSelector(
    state => state.user.info.fullName,
  ).split(' ');
  const userAvatar = useSelector(state => state.user.info.avatar);
  const redmineToken = useSelector(state => state.user.redmine_access_token);
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery(theme =>
    theme.breakpoints.maxWidth('sm'),
  );
  const [isAvatarMenuOpen, setIsAvatarMenuOpen] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const id = open ? 'avatar-menu' : undefined;

  const openDrawer = useCallback(
    () => dispatch(toggleDrawer(true)),
    [dispatch],
  );

  const { current: handleOpenAvatarMenu } = useRef(event => {
    setAnchorEl(event.currentTarget);
    setIsAvatarMenuOpen(true);
  });

  const { current: handleCloseAvatarMenu } = useRef(() => {
    setAnchorEl(null);
    setIsAvatarMenuOpen(false);
  });

  return (
    <StyledHeader
      container
      sx={{
        justifyContent: 'center',
      }}
    >
      <StyledHeaderContainer
        size='grow'
        container
        wrap='nowrap'
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Grid
          container
          sx={{
            width: 'auto',
          }}
        >
          {isSmallScreen && (
            <IconButton disableRipple onClick={openDrawer}>
              <MenuIcon width='24' height='24' viewBox='0 0 24 24' />
            </IconButton>
          )}
          <StyledHeaderLogo to='/'>
            <LogoIconWhite viewBox='0 0 88 40' />
          </StyledHeaderLogo>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <SearchInput />
          <HeaderNavIcons />
          {!isSmallScreen && (
            <StyledAvatarBlock>
              <UserAvatar
                avatar={userAvatar}
                userFirstName={userFirstName}
                userLastName={userLastName}
                userFullNameArray={userFullNameArray}
                handleOpenAvatarMenu={handleOpenAvatarMenu}
                aria-describedby={id}
              />
              {isAvatarMenuOpen && (
                <StyledUserSettingsLink
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleCloseAvatarMenu}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                >
                  {/*                  {process.env.NODE_ENV === 'development' ? (
                    <Link to="/my/account" onClick={handleCloseAvatarMenu}>
                      <Typography variant="h5" color="secondary">
                        <FormattedMessage id="my_account" />
                      </Typography>
                    </Link>
                  ) : (
                    <a href={generateRedirectUrl({ host: window.location.origin, path: '/my/account', redmineToken })}>
                      <Typography variant="h5" color="secondary">
                        <FormattedMessage id="my_account" />
                      </Typography>
                    </a>
                  )}*/}
                  <Link to='/my' onClick={handleCloseAvatarMenu}>
                    <Typography variant='h5' color='secondary'>
                      {getLocalString('labels', 'personalAccount')}
                    </Typography>
                  </Link>
                  <StyledLogoutButton to='/logout'>
                    <Typography variant='h5'>
                      {getLocalString('labels', 'logout')}
                    </Typography>
                  </StyledLogoutButton>
                </StyledUserSettingsLink>
              )}
            </StyledAvatarBlock>
          )}
        </Box>
      </StyledHeaderContainer>
    </StyledHeader>
  );
};

export default Header;
